import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InputGroupV2 from '../InputGroupV2';
import AsyncSelect from 'react-select/async';
import { getReactSelectStyles } from '../reactSelectTheme';
import { useReactSelectTabBlur } from '../reactSelectTabSelect';

const MultiSelectAsyncV2 = ({
  label,
  onChange,
  loadOptions,
  value,
  isRequired,
  error,
  helperText,
  disabled,
  placeholder,
}) => {
  const theme = useTheme();
  const { selectRef, tabSelectsValue, onKeyDown } = useReactSelectTabBlur();
  const selectStyles = useMemo(
    () => getReactSelectStyles(theme, { menuZIndex: 9999 }),
    [theme]
  );

  const DropdownIndicator = () => (
    <ArrowDropDownIcon sx={{ color: 'text.secondary' }} />
  );
  const IndicatorSeparator = () => '';

  return (
    <InputGroupV2 label={label} isRequired={isRequired}>
      <AsyncSelect
        ref={selectRef}
        cacheOptions
        defaultOptions={false}
        loadOptions={loadOptions}
        isMulti
        components={{ DropdownIndicator, IndicatorSeparator }}
        styles={selectStyles}
        onChange={onChange}
        onKeyDown={onKeyDown}
        tabSelectsValue={tabSelectsValue}
        value={value}
        placeholder={placeholder}
        noOptionsMessage={({ inputValue }) =>
          !inputValue ? 'Digite para pesquisar' : 'Nenhum resultado encontrado'
        }
        loadingMessage={() => 'Buscando...'}
        isDisabled={disabled}
        closeMenuOnSelect={false}
      />
      {error && (
        <Box
          component="p"
          sx={{
            color: 'error.main',
            mt: 1,
            mx: 1.5,
            fontSize: 11,
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            lineHeight: 1,
            m: 0,
          }}
        >
          {helperText || 'O Campo é obrigatório'}
        </Box>
      )}
    </InputGroupV2>
  );
};

MultiSelectAsyncV2.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  loadOptions: PropTypes.func.isRequired,
  value: PropTypes.array,
  isRequired: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

MultiSelectAsyncV2.defaultProps = {
  value: undefined,
  isRequired: false,
  error: false,
  helperText: undefined,
  disabled: false,
  placeholder: 'Digite para buscar...',
};

export default MultiSelectAsyncV2;
